import * as S from '@/components/Footer/style';
import FooterLogo from '@/assets/img/logo/greenLogo.png';
import LineIcon from '../Icon/lineIcon';
import useIsMobile from '@/hooks/useIsMobile';
import kaggLogo from '@/assets/img/logo/kagg.png';
const Footer = () => {
	const isMobile = useIsMobile(1225);
	return (
		<S.FooterContainer>
			<S.FooterWrapper>
				<S.FooterContent>
					<S.ImgBox>
						<img src={FooterLogo} alt="FooterLogo" />
					</S.ImgBox>
					<S.FooterAbout>
						<S.ContentBox>
							<S.FooterContact>
								<S.FooterInfo>단체명: 한국노화학회</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>사업장 주소: 인천광역시 미추홀구 인하로 100 인하대학교 5호관 동쪽 205B 노화생물학연구실 우)22212</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								{/* <S.FooterInfo>대표번호 : (032) 860-8193</S.FooterInfo> */}
								{/* {!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />} */}
								<S.FooterInfo>이메일: aging07@gmail.com</S.FooterInfo>
							</S.FooterContact>
							<S.FooterContact>
								<S.FooterInfo>고유번호: 408-82-65329</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>개인정보 관리 책임자: 민경진</S.FooterInfo>
							</S.FooterContact>
						</S.ContentBox>
						<S.CopyRight>COPYRIGHT © 한국노화학회 ALL RIGHT RESERVED.</S.CopyRight>
						<S.FooterLogo href="https://www.kagg.or.kr/" target="_blank">
							<img src={kaggLogo} alt="KAGG" />
						</S.FooterLogo>
					</S.FooterAbout>
				</S.FooterContent>
			</S.FooterWrapper>
		</S.FooterContainer>
	);
};

export default Footer;
